export default __webpack_public_path__ + "static/media/game-score-win-1.9d9a1f0f.mp3";